var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":"https://gx.fjtwfw.com/api/web/government/zwfw","width":"100%","height":"600","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }